export default {"src":"/_next/static/media/logo-text.68b68f9a.svg","height":21,"width":102,"blurWidth":0,"blurHeight":0};